"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = require("react");
var useForwardedRef_1 = __importDefault(require("./useForwardedRef"));
var useRefHasValue = function (ref, value) {
    var _a;
    var _b = react_1.useState(false), hasValue = _b[0], setHasValue = _b[1];
    var forwardedRef = useForwardedRef_1["default"](ref);
    react_1.useEffect(function () {
        var _a, _b;
        // @ts-ignore
        if ((_a = forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            setHasValue(true);
            // @ts-ignore
        }
        else if (!((_b = forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current) === null || _b === void 0 ? void 0 : _b.value) || !value) {
            setHasValue(false);
        }
        // @ts-ignore
    }, [(_a = forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current) === null || _a === void 0 ? void 0 : _a.value, value]);
    return {
        forwardedRef: forwardedRef,
        hasValue: hasValue,
        setHasValue: setHasValue
    };
};
exports["default"] = useRefHasValue;
